import withName from "../../hoc/withName";
import { useTranslation } from "react-i18next";
import { SERVICE_ADDITIONAL_API, SERVICE_ADDITIONAL_USER, SERVICE_DATAPLAN, SERVICE_DROPCONTROL, SERVICE_EXT_DATASOURCE, SERVICE_IMAGES, SERVICE_SMS_CALLS } from "../../utils/BillingUtils";

import ServiceForm from "./ServiceForm";

import { Accordion, AccordionTab } from "primereact/accordion";

const DISABLE_IMAGES = true;

const PriceListServices = ({formik, indexes}) => {

    const { t } = useTranslation();
    return (
        <div className='col-xl-6 col-lg-12 col-sm-12'>
            <div className='card'>
                <div className="card-body">
                    <div className='row'>
                        <div className='col-xl-12 col-lg-12 col-sm-12  text-center'>
                            <h5 className="card-title"><span>{t("billing.priceListPage.services")}</span></h5>
                        </div>
                    </div>
                    <div className='linea-titulo' />
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
                            <Accordion multiple activeIndex={[]} className='servicePLAcc'>
                                <AccordionTab header={
                                    <div className='centerAlignTD'>
                                        {t("billing.priceListPage.serviceLabels.1")}
                                    </div>
                                }
                                >
                                    <ServiceForm
                                        service={SERVICE_DROPCONTROL} values={formik.values}
                                        setFieldValue={formik.setFieldValue} indexes={indexes}
                                    />
                                </AccordionTab>
                                <AccordionTab header={
                                    <div className='centerAlignTD'>
                                        {t("billing.priceListPage.serviceLabels.2")}
                                    </div>
                                }
                                >
                                    <ServiceForm
                                        service={SERVICE_DATAPLAN} values={formik.values}
                                        setFieldValue={formik.setFieldValue} indexes={indexes}
                                    />
                                </AccordionTab>
                                <AccordionTab header={
                                    <div className='centerAlignTD'>
                                        {t("billing.priceListPage.serviceLabels.3")}
                                    </div>
                                }
                                >
                                    <ServiceForm
                                        service={SERVICE_EXT_DATASOURCE} values={formik.values}
                                        setFieldValue={formik.setFieldValue} indexes={indexes}
                                    />
                                </AccordionTab>
                                <AccordionTab header={
                                    <div className='centerAlignTD'>
                                        {t("billing.priceListPage.serviceLabels.4")}
                                    </div>
                                }
                                >
                                    <ServiceForm
                                        service={SERVICE_ADDITIONAL_USER} values={formik.values}
                                        setFieldValue={formik.setFieldValue} indexes={indexes}
                                    />
                                </AccordionTab>
                                <AccordionTab header={
                                    <div className='centerAlignTD'>
                                        {t("billing.priceListPage.serviceLabels.5")}
                                    </div>
                                }
                                >
                                    <ServiceForm
                                        service={SERVICE_SMS_CALLS} values={formik.values}
                                        setFieldValue={formik.setFieldValue} indexes={indexes}
                                    />
                                </AccordionTab>
                                {DISABLE_IMAGES ? null :
                                    <AccordionTab header={
                                        <div className='centerAlignTD'>
                                            {t("billing.priceListPage.serviceLabels.6")}
                                        </div>
                                    }
                                    >
                                        <ServiceForm
                                            service={SERVICE_IMAGES} values={formik.values}
                                            setFieldValue={formik.setFieldValue} indexes={indexes}
                                        />
                                    </AccordionTab>}
                                <AccordionTab header={
                                    <div className='centerAlignTD'>
                                        {t("billing.priceListPage.serviceLabels.7")}
                                    </div>
                                }
                                >
                                    <ServiceForm
                                        service={SERVICE_ADDITIONAL_API} values={formik.values}
                                        setFieldValue={formik.setFieldValue} indexes={indexes}
                                    />
                                </AccordionTab>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withName(PriceListServices, "PriceListServices");
